var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDangerous(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15089_468",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15089_468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3438 26.25C11.0104 26.25 10.6927 26.1875 10.3906 26.0625C10.0885 25.9375 9.82292 25.7604 9.59375 25.5313L4.46875 20.4062C4.23958 20.1771 4.0625 19.9115 3.9375 19.6094C3.8125 19.3073 3.75 18.9896 3.75 18.6562V11.3438C3.75 11.0104 3.8125 10.6927 3.9375 10.3906C4.0625 10.0885 4.23958 9.82292 4.46875 9.59375L9.59375 4.46875C9.82292 4.23958 10.0885 4.0625 10.3906 3.9375C10.6927 3.8125 11.0104 3.75 11.3438 3.75H18.6562C18.9896 3.75 19.3073 3.8125 19.6094 3.9375C19.9115 4.0625 20.1771 4.23958 20.4062 4.46875L25.5313 9.59375C25.7604 9.82292 25.9375 10.0885 26.0625 10.3906C26.1875 10.6927 26.25 11.0104 26.25 11.3438V18.6562C26.25 18.9896 26.1875 19.3073 26.0625 19.6094C25.9375 19.9115 25.7604 20.1771 25.5313 20.4062L20.4062 25.5313C20.1771 25.7604 19.9115 25.9375 19.6094 26.0625C19.3073 26.1875 18.9896 26.25 18.6562 26.25H11.3438ZM15 16.75L17.6875 19.4375C17.9167 19.6667 18.2083 19.7812 18.5625 19.7812C18.9167 19.7812 19.2083 19.6667 19.4375 19.4375C19.6667 19.2083 19.7812 18.9167 19.7812 18.5625C19.7812 18.2083 19.6667 17.9167 19.4375 17.6875L16.75 15L19.4375 12.3125C19.6667 12.0833 19.7812 11.7917 19.7812 11.4375C19.7812 11.0833 19.6667 10.7917 19.4375 10.5625C19.2083 10.3333 18.9167 10.2188 18.5625 10.2188C18.2083 10.2188 17.9167 10.3333 17.6875 10.5625L15 13.25L12.3125 10.5625C12.0833 10.3333 11.7917 10.2188 11.4375 10.2188C11.0833 10.2188 10.7917 10.3333 10.5625 10.5625C10.3333 10.7917 10.2188 11.0833 10.2188 11.4375C10.2188 11.7917 10.3333 12.0833 10.5625 12.3125L13.25 15L10.5625 17.6875C10.3333 17.9167 10.2188 18.2083 10.2188 18.5625C10.2188 18.9167 10.3333 19.2083 10.5625 19.4375C10.7917 19.6667 11.0833 19.7812 11.4375 19.7812C11.7917 19.7812 12.0833 19.6667 12.3125 19.4375L15 16.75Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerous);
export default __webpack_public_path__ + "static/media/dangerous.52ed1da1474f316c2e3d441d4917c16c.svg";
export { ForwardRef as ReactComponent };